import { isAbsoluteUrl } from './isAbsoluteUrl.js';

const withoutTrailingSlash = url => url.replace(/\/$/, '');

const withoutLeadingSlash = url => url.replace(/^\//, '');

function joinUrls(base, url) {
  if (!base) {
    return url;
  }

  if (!url) {
    return base;
  }

  if (isAbsoluteUrl(url)) {
    return url;
  }

  base = withoutTrailingSlash(base);
  url = withoutLeadingSlash(url);
  return `${base}/${url}`;
}

export { joinUrls };
//# sourceMappingURL=joinUrls.js.map
